export default {
    computed: {
        //提醒规则类型
        getRuleTypes() {
            return [{
                value: 1,
                label: '用户规则',
            }, {
                value: 2,
                label: '管理规则',
            }]
        },
        //通知类型
        getNoticeTypes() {
            return [{
                value: 1,
                label: '公告',
            }, {
                value: 2,
                label: '提醒',
            }, {
                value: 3,
                label: '私信',
            }, {
                value: 4,
                label: '群消息',
            }]
        },
        //消息事件类型
        getNoticeEevntTypes() {
            return this.$store.state.layout.noticeEventTypes.map((item) => {
                return {
                    value: item.id,
                    label: item.title
                }
            })
        },
        getRuleStatus() {
            return [{
                value: 1,
                label: '已启用',
            }, {
                value: 2,
                label: '已停用',
            }]
        },
        getTemplateStatus() {
            return [{
                value: 1,
                label: '已启用',
            }, {
                value: 2,
                label: '已停用',
            }]
        },
        //消息是否已读
        getReadNoticeList() {
            return [{
                value: 0,
                label: '未读',
            }, {
                value: 1,
                label: '已读',
            }]
        },
        //通知方式
        getSendChannels() {
            return [{
                value: 'inbox',
                label: '站内信',
            }, {
                value: 'email',
                label: '邮件',
            },
            // ,  {
            //     value: 'sms',
            //     label: '短信',
            // }
            {
                value: 'dingtalkbot',
                label: '钉钉群机器人',
            }]
        },
        //事件等级
        getAppLevel() {
            return [
                {
                    value: 0,
                    label: '未设定',
                }, {
                    value: 100,
                    label: '调试',
                }, {
                    value: 200,
                    label: '信息',
                }, {
                    value: 250,
                    label: '提示',
                }, {
                    value: 300,
                    label: '警告',
                }, {
                    value: 400,
                    label: '错误',
                }, {
                    value: 500,
                    label: '严重',
                }, {
                    value: 550,
                    label: '报警',
                }, {
                    value: 600,
                    label: '紧急',
                }
            ]
        },
        //通知人
        getNotifierList() {
            return [{
                key: 'toSourceCreator',
                label: '单据创建人',
            }, {
                key: 'toProjectAgent',
                label: '项目经理',
            }, {
                key: 'toAccountAgent',
                label: '渠道负责人',
            }, {
                key: 'toServiceAgent',
                label: '公司负责人',
            }, {
                key: 'toCustomeCreator',
                label: '指定通知人',
            }]
        },
    },
}
